"use strict";
exports.__esModule = true;
exports.ActivityDocument = void 0;
var ActivityDocument = /** @class */ (function () {
    function ActivityDocument(data) {
        Object.assign(this, data); // Dynamically assign properties
    }
    ActivityDocument.fromJSON = function (json) {
        var activity = new ActivityDocument({});
        if (json) {
            Object.assign(activity, json);
        }
        return activity;
    };
    return ActivityDocument;
}());
exports.ActivityDocument = ActivityDocument;
